import { render } from "./ProceduresForUse.vue?vue&type=template&id=e1fb50ec&scoped=true"
import script from "./ProceduresForUse.vue?vue&type=script&lang=js"
export * from "./ProceduresForUse.vue?vue&type=script&lang=js"

import "./ProceduresForUse.vue?vue&type=style&index=0&id=e1fb50ec&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1fb50ec"]])

export default __exports__